/**
 * Остаток на складе из строки корзины API (у OrderItemResponse поле в JSON — «available quantity»).
 */
export function availableStockFromCartLine(line) {
    if (line == null) {
        return 0;
    }
    const raw = line.count ?? line['available quantity'];
    const n = Number(raw);
    return Number.isFinite(n) ? Math.max(0, n) : 0;
}

/**
 * Лимит для UI: не меньше, чем в каталоге и не меньше, чем в последней строке корзины (актуальный остаток с сервера).
 */
export function effectiveStockCap(catalogCount, cartLine) {
    const fromCatalog = Number(catalogCount) || 0;
    const fromCart = availableStockFromCartLine(cartLine);
    return Math.max(fromCatalog, fromCart);
}
